createLanguageQueryParam